import { useState, useEffect } from "react";

const productCategories = [
  {
    id: "capacitor",
    icon: "ri-flashlight-line",
    title: "电容器",
    subtitle: "Capacitors",
    color: "#0EA5E9",
    bgColor: "#0EA5E9",
    description: "涵盖贴片陶瓷、中高压瓷片、独石、铝电解、薄膜、电力及超高压电容等全系列产品，满足消费电子、工业控制、新能源等领域需求。",
    tags: ["贴片陶瓷电容", "中高压瓷片电容", "独石电容", "铝电解电容", "薄膜电容", "电力电容", "超高压电容"],
    image: "https://readdy.ai/api/search-image?query=close%20up%20macro%20photo%20of%20various%20capacitors%20SMD%20ceramic%20capacitors%20electrolytic%20capacitors%20arranged%20neatly%20on%20white%20clean%20background%2C%20professional%20product%20photography%2C%20sharp%20detail%2C%20industrial%20electronic%20components&width=600&height=400&seq=geruite-cap1&orientation=landscape",
  },
  {
    id: "inductor",
    icon: "ri-signal-wifi-line",
    title: "电感器",
    subtitle: "Inductors",
    color: "#10B981",
    bgColor: "#10B981",
    description: "提供高频叠层、铁氧体叠层、绕线叠层、功率电感、片式磁珠、3端子滤波器、共模滤波器、变压器及磁性器件，广泛应用于通信、电源管理领域。",
    tags: ["高频叠层电感", "铁氧体叠层电感", "绕线叠层电感", "功率电感", "片式磁珠", "3端子滤波器", "共模滤波器", "变压器"],
    image: "https://readdy.ai/api/search-image?query=power%20inductors%20ferrite%20chip%20inductors%20electronic%20components%20macro%20photography%20clean%20white%20background%2C%20SMD%20inductors%20arranged%20professionally%2C%20sharp%20detail%2C%20industrial%20product%20photo&width=600&height=400&seq=geruite-ind1&orientation=landscape",
  },
  {
    id: "semiconductor",
    icon: "ri-cpu-line",
    title: "半导体元器件",
    subtitle: "Semiconductors",
    color: "#F59E0B",
    bgColor: "#F59E0B",
    description: "涵盖肖特基二极管、中低压MOS管、传感器、TVS管、整流桥及碳化硅器件，为各类电路保护、功率转换提供高效、可靠的半导体方案。",
    tags: ["肖特基二极管", "中低压MOS", "传感器", "TVS管", "整流桥", "碳化硅SiC"],
    image: "https://readdy.ai/api/search-image?query=semiconductor%20electronic%20components%20diodes%20transistors%20MOSFET%20chips%20IC%20packages%20arranged%20on%20white%20background%2C%20professional%20product%20photography%2C%20micro%20detail%2C%20industrial%20components%20sharp%20focus&width=600&height=400&seq=geruite-semi1&orientation=landscape",
  },
  {
    id: "optoelectronic",
    icon: "ri-lightbulb-flash-line",
    title: "光电元器件",
    subtitle: "Optoelectronics",
    color: "#8B5CF6",
    bgColor: "#8B5CF6",
    description: "提供发光二极管、光耦、光感应器、红外器件及显示模块等产品，广泛应用于照明、工业自动化、消费电子等领域的光电信号处理场景。",
    tags: ["发光二极管LED", "光耦", "光感应器", "红外器件", "显示模块"],
    image: "https://readdy.ai/api/search-image?query=LED%20components%20optocouplers%20infrared%20sensors%20photodetectors%20electronic%20components%20on%20white%20background%2C%20colorful%20LED%20diodes%20product%20photography%2C%20professional%20macro%20detail%2C%20industrial%20optoelectronics&width=600&height=400&seq=geruite-opto1&orientation=landscape",
  },
  {
    id: "thermocouple",
    icon: "ri-temp-hot-line",
    title: "热电偶 / 热电阻",
    subtitle: "Thermocouples & RTDs",
    color: "#EF4444",
    bgColor: "#EF4444",
    description: "提供装配式和铠装式热电偶与热电阻系列产品，精准测温范围宽广，适用于冶金、化工、电力、机械等工业生产环境的温度检测与控制。",
    tags: ["装配式热电偶", "铠装式热电偶", "装配式热电阻", "铠装式热电阻"],
    image: "https://readdy.ai/api/search-image?query=industrial%20thermocouples%20temperature%20sensors%20RTD%20probes%20metal%20sheathed%20thermal%20sensors%20on%20clean%20white%20background%2C%20professional%20industrial%20product%20photography%2C%20sharp%20detail%2C%20precision%20instruments&width=600&height=400&seq=geruite-thermo1&orientation=landscape",
  },
  {
    id: "transformer",
    icon: "ri-router-line",
    title: "网络变压器",
    subtitle: "Network Transformers",
    color: "#06B6D4",
    bgColor: "#06B6D4",
    description: "全品类网络变压器，覆盖以太网、PoE、千兆及万兆应用，支持10/100/1000Base-T等多种标准，广泛用于网络设备、通信基础设施领域。",
    tags: ["以太网变压器", "PoE变压器", "千兆变压器", "万兆变压器", "全品类网络变压器"],
    image: "https://readdy.ai/api/search-image?query=network%20transformers%20ethernet%20magnetic%20components%20RJ45%20connector%20modules%20electronic%20parts%20on%20white%20background%2C%20professional%20product%20photography%2C%20network%20equipment%20components%2C%20industrial%20precision%20parts&width=600&height=400&seq=geruite-trans1&orientation=landscape",
  },
  {
    id: "protection",
    icon: "ri-shield-check-line",
    title: "保护器件",
    subtitle: "Protection Devices",
    color: "#F97316",
    bgColor: "#F97316",
    description: "PPTC自恢复保险丝系列，提供过流保护解决方案，具有自恢复特性，无需更换即可自动恢复工作状态，广泛用于消费电子、通信、工业控制等领域。",
    tags: ["PPTC自恢复保险丝", "过流保护", "自恢复保护"],
    image: "https://readdy.ai/api/search-image?query=PPTC%20resettable%20fuses%20protection%20devices%20electronic%20components%20on%20white%20background%2C%20circuit%20protection%20components%2C%20professional%20product%20photography%2C%20sharp%20detail%2C%20industrial%20safety%20components&width=600&height=400&seq=geruite-prot1&orientation=landscape",
  },
];

export default function Products() {
  const [activeId, setActiveId] = useState("capacitor");
  const active = productCategories.find((p) => p.id === activeId) || productCategories[0];

  useEffect(() => {
    const handleSetCategory = (e: Event) => {
      const detail = (e as CustomEvent<{ id: string }>).detail;
      if (detail?.id) setActiveId(detail.id);
    };
    window.addEventListener("setProductCategory", handleSetCategory);
    return () => window.removeEventListener("setProductCategory", handleSetCategory);
  }, []);

  return (
    <section id="products" className="py-24 bg-[#F0F6FF]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0EA5E9]/10 mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]" />
              <span className="text-[#0EA5E9] text-xs font-semibold tracking-wider">CORE PRODUCTS</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0D1F3C]">核心产品系列</h2>
            <p className="text-gray-500 text-base mt-2">覆盖七大品类，满足多场景电子元器件需求</p>
          </div>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-flex items-center gap-2 text-[#0EA5E9] text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            获取选型支持
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left: Category list */}
          <div className="flex flex-col gap-2">
            {productCategories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveId(cat.id)}
                className={`flex items-center gap-4 px-5 py-4 rounded-xl text-left transition-all duration-200 cursor-pointer ${
                  activeId === cat.id
                    ? "bg-[#0A1628] text-white shadow-lg"
                    : "bg-white hover:bg-[#0A1628]/5 text-gray-700"
                }`}
              >
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0"
                  style={{
                    backgroundColor: activeId === cat.id ? `${cat.color}30` : `${cat.color}15`,
                  }}
                >
                  <i className={`${cat.icon} text-base`} style={{ color: cat.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-semibold truncate ${activeId === cat.id ? "text-white" : "text-[#0D1F3C]"}`}>
                    {cat.title}
                  </p>
                  <p className={`text-xs mt-0.5 ${activeId === cat.id ? "text-gray-400" : "text-gray-500"}`}>
                    {cat.subtitle}
                  </p>
                </div>
                {activeId === cat.id && (
                  <i className="ri-arrow-right-s-line text-[#0EA5E9] flex-shrink-0" />
                )}
              </button>
            ))}
          </div>

          {/* Right: Active product detail */}
          <div className="lg:col-span-2 bg-white rounded-2xl overflow-hidden border border-gray-100">
            {/* Product image */}
            <div className="relative w-full h-64 overflow-hidden">
              <img
                key={active.id}
                src={active.image}
                alt={`${active.title}产品图`}
                className="w-full h-full object-cover object-top transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/30 to-transparent" />
              <div
                className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 rounded-full"
                style={{ backgroundColor: `${active.color}20`, border: `1px solid ${active.color}40` }}
              >
                <i className={`${active.icon} text-xs`} style={{ color: active.color }} />
                <span className="text-xs font-semibold" style={{ color: active.color }}>
                  {active.subtitle}
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="p-8">
              <h3 className="text-2xl font-bold text-[#0D1F3C] mb-3">{active.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6">{active.description}</p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-8">
                {active.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs font-medium border"
                    style={{
                      color: active.color,
                      borderColor: `${active.color}40`,
                      backgroundColor: `${active.color}08`,
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* CTA */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <button
                  onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-lg text-white text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
                  style={{ backgroundColor: active.color }}
                >
                  <i className="ri-mail-send-line" />
                  询价/选型
                </button>
                <div className="flex items-center gap-2 text-gray-400 text-xs">
                  <i className="ri-information-line" />
                  <span>如需样品或技术规格，欢迎联系我们</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {[
            { icon: "ri-global-line", title: "原厂授权分销", desc: "主流品牌正规渠道" },
            { icon: "ri-stack-line", title: "现货充足库存", desc: "10000+ SKU 随时备货" },
            { icon: "ri-tools-line", title: "专业技术选型", desc: "工程师团队全程支持" },
            { icon: "ri-time-line", title: "高效响应交付", desc: "快速报价，准时发货" },
          ].map((item) => (
            <div key={item.title} className="flex items-start gap-3 bg-white rounded-xl p-5 border border-gray-100">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#0EA5E9]/10 flex-shrink-0">
                <i className={`${item.icon} text-[#0EA5E9]`} />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#0D1F3C]">{item.title}</p>
                <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
